// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		//Booking widget 
		var triggerBooking = document.querySelector('.js-reserve');
		var bookingWindow = document.getElementById('booking-widget');
		var closeBooking = document.querySelector('.close-booking');
		var closeMenu = document.querySelector('.close-menu');
		var triggerBookingM = document.querySelector('.js-nav');
		var mobileNav = document.querySelector('.mobile-navigation');
		var mobileMenu = document.querySelector('.js-menu');
		//Open Booking
		if(triggerBooking){
			triggerBooking.addEventListener('click', function (e) {
				bookingWindow.classList.add("open");
				e.preventDefault();
			})

			if(triggerBookingM){
				//Open Booking Mobile
				triggerBookingM.addEventListener('click', function(e){
					bookingWindow.classList.add("open")
					e.preventDefault();
				})
			}

			if(closeBooking){
				//Close Booking
				closeBooking.addEventListener('click', function (e) {
					bookingWindow.classList.remove("open");
					e.preventDefault();
				})
			}
		}

		if(closeMenu){
			closeMenu.addEventListener('click', function (e) {
				mobileNav.classList.remove("open");
				e.preventDefault();
			})
		}

		//Mobile menu
		if(mobileMenu){
			mobileMenu.addEventListener('click', function(e){
				mobileNav.classList.add('open')
				e.preventDefault()
			})
		}
		//Slick JS
		$('.carousel__container').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: '20%',
			mobileFirst:true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: '20%',
						arrows:true
					}
				},
				{
					breakpoint: 390,
					settings: {
						arrows:true,
						centerPadding: '6%'
					}
				}
			]
		});

		$('.content-slider__content').slick({
			arrows: false,
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			cssEase: 'linear',
		});

		$('.menus-carousel__content .elements').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			asNavFor: '.menus-carousel__titles .elements',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 1008,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centermode:false,
						centerPadding:0
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows:false,
						centerMode:false
					}
				}
			]
		});

		$('.menus-carousel__titles .elements').slick({
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: '28%',
			asNavFor: '.menus-carousel__content .elements',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 1008,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centermode:false,
						centerPadding:0
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centermode:false,
						centerPadding:0,
						dots:true,
						appendDots:'.dotsMobile'
					}
				}
			]
		});
		$('.sym-slides-custom').slick({
			accessibility: true, 
			arrows: true,
			responsive: [
				{
				  breakpoint: 768,
				  settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '40px',
					slidesToShow: 3
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					arrows: false,
					dots: true,
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 1
				  }
				}
			  ]
			
		});

		//Fancybox 
		//$('.private-events').fancybox();
		//$('.indulgence').fancybox();


		//Acts when scroll down page.
		$(window).scroll(function (event) {
			//scrollDown();
		});

		//Select2
		$('#language').select2();
		$('#language').on('select2:selecting', function(e) {
			changeLanguage(e.params.args.data.id);
		});

		// Main Nav Dropdown
		// $("#primary-nav li").hover(function(){
		// 	$(this).addClass("hover");
		// 	$('ul.submenu',this).fadeIn(200);
		// }, function(){
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu',this).fadeOut(200);
		// });

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		$("#CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#CheckOut").datepicker("setDate", newDate);
				$("#CheckOut").datepicker("option", "minDate", selectedDate);
			}
		});
		$("#CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

	// if(document.querySelector('.menus-quad')){
	// 	let tabsMenu = document.querySelectorAll('.menus-quad__filter ul li');
	// 	let allMenus = document.querySelectorAll('.menus-quad__container .menus-quad__menu');
	// 	let lastClickMenu = null;
	
	// 	tabsMenu.forEach((tab)=>{
	// 	  tab.addEventListener('click', ()=>{
	// 		let menuId = tab.dataset.menu;
	// 		if(lastClickMenu){
	// 		  lastClickMenu.classList.remove('active');
	// 		}
	// 		tab.classList.add('active');
	// 		allMenus.forEach((menu)=>{
	// 		  menu.classList.toggle('hidden', menuId != menu.dataset.menu);
	// 		})
	// 		lastClickMenu = tab;
	// 	  })
	// 	})
	
	// 	tabsMenu[0].click();
	//   }

}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}